module.exports = __webpack_public_path__ + "media/images/icon/icons8-View Details-0590037fe7373e79315b7639d410e98c.png";